import { Head, Link, useForm } from '@inertiajs/react'
import Flash from '../../components/Flash'

const FLOATIES = [
  { emoji: '🧸', className: 'left-[8%] top-[18%] text-6xl', delay: '0s' },
  { emoji: '🎈', className: 'right-[10%] top-[12%] text-5xl', delay: '1.2s' },
  { emoji: '🌙', className: 'left-[14%] bottom-[14%] text-5xl', delay: '2.1s' },
  { emoji: '⭐️', className: 'right-[16%] bottom-[20%] text-4xl', delay: '0.6s' },
  { emoji: '🐣', className: 'right-[26%] top-[46%] text-4xl', delay: '3s' },
]

export default function SignIn({ username }) {
  const { data, setData, post, processing } = useForm({
    username: username || '',
    password: '',
  })

  function submit(event) {
    event.preventDefault()
    post('/session')
  }

  return (
    <>
      <Head title="Sign in" />
      <Flash />

      <main className="relative flex min-h-screen items-center justify-center overflow-hidden px-5 py-12">
        {FLOATIES.map((floaty) => (
          <span
            key={floaty.emoji}
            aria-hidden="true"
            style={{ animationDelay: floaty.delay }}
            className={`animate-float-slow pointer-events-none absolute hidden opacity-70 select-none sm:block ${floaty.className}`}
          >
            {floaty.emoji}
          </span>
        ))}

        <div className="card-cute animate-pop-in w-full max-w-md p-8">
          <div className="mb-7 text-center">
            <span className="animate-float-slow inline-block text-6xl" aria-hidden="true">
              🍼
            </span>
            <h1 className="mt-3 font-display text-4xl font-extrabold text-ink">Baby Campbell</h1>
            <p className="mt-2 text-ink-soft">
              A tiny, private album just for friends and family. Sign in to see the newest wiggles.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label htmlFor="username" className="mb-1.5 block font-display font-bold text-ink-soft">
                Username
              </label>
              <input
                id="username"
                type="text"
                name="username"
                value={data.username}
                onChange={(event) => setData('username', event.target.value)}
                required
                autoFocus
                autoComplete="username"
                autoCapitalize="none"
                spellCheck="false"
                placeholder="grandma_jo"
                className="input-cute"
              />
            </div>

            <div>
              <label htmlFor="password" className="mb-1.5 block font-display font-bold text-ink-soft">
                Password
              </label>
              <input
                id="password"
                type="password"
                name="password"
                value={data.password}
                onChange={(event) => setData('password', event.target.value)}
                required
                autoComplete="current-password"
                maxLength={72}
                placeholder="••••••••"
                className="input-cute"
              />
            </div>

            <button
              type="submit"
              disabled={processing}
              className="btn-cute w-full bg-blush-400 py-3 text-lg text-white shadow-lg hover:bg-blush-500"
            >
              {processing ? 'Peeking in…' : 'Let me in 👶'}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-ink-soft/80">
            No account?{' '}
            <Link href="/request-access" className="font-bold text-blush-500 underline-offset-2 hover:underline">
              Request one!
            </Link>
          </p>
        </div>
      </main>
    </>
  )
}
